import { useCallback, useEffect, useState } from 'react';

/** Полноэкранный режим обёртки плеера + отслеживание его изменения извне (Esc и т.п.) */
export const useFullscreen = (wrapperRef, allowFullscreen) => {
	const [isFullscreen, setIsFullscreen] = useState(false);

	const toggleFullscreen = useCallback(async () => {
		if (!allowFullscreen || !wrapperRef.current) return;
		const el = wrapperRef.current;
		try {
			if (!document.fullscreenElement) {
				await el.requestFullscreen();
			} else {
				await document.exitFullscreen();
			}
		} catch {
			const video = el.querySelector('video');
			if (video?.webkitEnterFullscreen) {
				video.webkitEnterFullscreen();
			}
		}
	}, [allowFullscreen, wrapperRef]);

	useEffect(() => {
		const onFullscreenChange = () => {
			setIsFullscreen(!!document.fullscreenElement);
		};
		document.addEventListener('fullscreenchange', onFullscreenChange);
		document.addEventListener('webkitfullscreenchange', onFullscreenChange);
		return () => {
			document.removeEventListener('fullscreenchange', onFullscreenChange);
			document.removeEventListener('webkitfullscreenchange', onFullscreenChange);
		};
	}, []);

	return { isFullscreen, toggleFullscreen };
};
